import React, { useEffect } from "react";
import { Button, Table, Switch, Tooltip, Space } from "antd";
import { useModel } from "../../../models"
import CustomerModel from "./CustomerModel.jsx"
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const TableHeader = () => {
    const [{ ModelVisible, ModelParams, accountRow }, { setModelVisible, setModelParams }] = useModel('customerBill')
    const onDetail = () => {
        setModelVisible(!ModelVisible)
        setModelParams({
            title: "账户调额",
            Visible: !ModelParams.Visible,
            type: "tiaoer"
        })
    }
    const onPay = () => {
        setModelVisible(!ModelVisible)
        setModelParams({
            title: "账户充值",
            Visible: !ModelParams.Visible,
            type: "chozhi"
        })
    }
    const transfer = () => {
        setModelVisible(!ModelVisible)
        setModelParams({
            title: "账户转账",
            Visible: !ModelParams.Visible,
            type: "zhuanzhang"
        })
    }

    return (
        <div style={{ margin: "0 0 8px", display: "flex" }}>
            <div style={{ width: "460px", paddingTop: "6px" }}>
                <YhAuth resCode={ResourceAuthEnum.ACC_C_ADI}>
                    <Tooltip placement="topLeft" title="调整额度只能账户类型为授信用户，才可以调整额度">
                        <Button className="margin-left-8" onClick={onDetail}
                            disabled={(accountRow && accountRow.accountType == "009001" ? false : true)}>调额</Button>
                    </Tooltip>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.ACC_C_CHARG}>
                    <Button type="primary" disabled={!!!accountRow} className="margin-left-8" onClick={onPay}>充值</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.ACC_C_TRANS}>
                    <Button type="primary" className="margin-left-8" onClick={transfer}>转账</Button>
                </YhAuth>
            </div>
        </div>
    )
}

export default function () {
    const [{
        selectedCustomerRow,
        selectedCustomeRowKeys,
        accountList,
        accountRow,
        accountRowKeys,
        tabsKey
    }, {
        loadAccountList,
        setAccountRow,
        setAccountRowKeys,
        enableOrDisableAccount
    }] = useModel('customerBill')
    const [{ accountTypeDict }, { getAccountTypeDict, getPayTypeDict }] = useModel("cmDict");
    useEffect(() => {
        getAccountTypeDict()
        getPayTypeDict()
    }, [tabsKey])
    const columns = [
        {
            title: '账户编号',
            dataIndex: 'accountCode',
        },
        {
            title: '账户类型',
            dataIndex: 'accountType',
            render: (text, record) => {
                return (
                    <span>
                        {
                            accountTypeDict.map((item) => {
                                if (item.key == text) {
                                    return item.label
                                }
                            })
                        }
                    </span>
                )
            }
        },
        {
            title: '授信额度',
            dataIndex: 'creditLine',
        },
        {
            title: <span className="">已用授信额度</span>,
            dataIndex: 'usedCreditLine',
        },
        {
            title: <span className="">可用额度</span>,
            dataIndex: 'availableCredit',
        },
        {
            title: <span className="">剩余金额</span>,
            dataIndex: 'remainingAmount',
        },
        {
            title: <span className="">抹零金额</span>,
            dataIndex: 'omitAmount',
        },
        {
            title: <span className="">账户状态</span>,
            dataIndex: 'accountStatus',
            // render: (text,record) =>{return <Switch  checkedChildren="开启" unCheckedChildren="关闭"  checked={text===1} onChange={(checked)=>onChangSwitch(record,checked)}></Switch>}
            render: (text, record) => (
                <Space size="middle" onClick={e => e.stopPropagation()}>
                    <Switch
                        checked={record.accountStatus === 0}
                        onChange={(checked) => {
                            onChangSwitch(record, checked);
                        }}
                        size="small" />
                </Space>
            ),
        },
        {
            title: '备注',
            dataIndex: 'remarks',
        },
    ];

    useEffect(() => {
        loadAccountList({ showMsg: false, data: selectedCustomerRow ? selectedCustomerRow.id : null })
    }, [selectedCustomeRowKeys, tabsKey])

    const onChangSwitch = (record, checked) => {
        let { accountCode, id } = record
        let accountStatus = checked ? 0 : 1
        enableOrDisableAccount({ showMsg: true, data: { id, accountStatus } })

        // enableOrDisableAccount({data:{id,checkeds}})
    }
    return (
        <>
            <TableHeader />
            <Table
                columns={columns}
                dataSource={accountList}
                bordered
                pagination={true}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (record.accountStatus == 1) {
                                setAccountRow(null);
                                setAccountRowKeys([]);
                            } else {
                                if (accountRow && accountRow.key === record.key) {
                                    setAccountRow(null);
                                    setAccountRowKeys([]);
                                } else {
                                    setAccountRow(record);
                                    setAccountRowKeys([record.key]);
                                }
                            }
                        },
                    };
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys, selectedRows) => {
                        // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                        setAccountRow(selectedRows[0]);
                        setAccountRowKeys(selectedRowKeys);
                    },
                    getCheckboxProps: record => ({
                        disabled: record.accountStatus === 1,
                        name: record.name,
                    }),
                    selectedRowKeys: accountRowKeys
                }}
                scroll={{ x: 'max-content' }}
            />
            <CustomerModel />
        </>
    );
}